import React, { useEffect, useState } from "react";
import ThreeDots from "../../images/DotsThree.svg";
import API from "../../api/indexv2";
import { get } from "lodash";
import { Modal, ModalBody } from "reactstrap";
import { GET_USER_ADDRESS } from "../../api/apiList";
import { handleError } from "../../components/common/utils";
import { useSelector, useDispatch } from "react-redux";
import blacksearchIcon from "../../images/home/location-pin-green.svg";
import searchIcon from "../../images/searchIcon.svg";
import WrappedMap from "../../components/Map/map";
import Loader from "../../components/common/loader";
import EmptyPage from "../EmptyPage/component";
import AddressNotFound from "../EmptyPage/images/address-not-found.svg";
import { getPlacesDetails, placeDetail, handleAddress } from "../../api/ApiService";
import store from "../../store";
import { getLocations, saveSearchHistory, startLoadingMap } from "../../slices/mapSlice";
import debounce from "lodash/debounce";
import { USER_DATA } from "../../components/common/constant";
import "./styles.scss";
import { fetchSellers } from "../../slices/sellerSlice";
import { notify } from "../../components/common/utils";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../slices/userSlice";
import ArrowBack from "../../images/home/arrow_back.svg";
import CurrentLocationIcon from "../../images/home/current-location-icon.svg";
import LocationPinIcon from "../../images/home/location-pin-icon.svg";
import LoaderWhite from "../../components/common/LoaderWhite";

const ManageAddress = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { setZipcode, isInHeader, onAddressSelected, setAddressModal, setShippingAddress } = props;
  const [userAddress, setUserAddress] = useState([]);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [selectDeleteAddress, setDeletedAddress] = useState({});
  const [addressStatus, setAddressStatus] = useState("");
  const [editAddress, setEditAddress] = useState({});
  const address = useSelector((s) => s.mapApi.address);
  const addresses = useSelector((s) => s.address);
  const [tempAddress, setTempAddress] = useState({});
  const [getCurrentLocationLoader, setGetCurrentLocationLoader] = useState(false);
  const [loadingAddAddress, setLoadingAddAddress] = useState(false);
  const [searchmodal, setSearchModal] = useState(false);
  const [openFromEdit, setOpenFromEdit] = useState(false);
  const locations = useSelector((s) => s.mapApi.locations);
  const loadingMapAddress = useSelector((s) => s.mapApi.startLoadingMap);
  const selectAddressLoader = useSelector((s) => s.mapApi.selectAddressMapLoading);
  const recentSearches = useSelector((s) => s.mapApi.searchHistory);
  const [map, setMap] = useState(false);
  const [building, setBuilding] = useState("");

  const getUserFromLocalStorage = () => {
    try {
      return JSON.parse(localStorage.getItem(USER_DATA) || "");
    } catch (error) {
      return null;
    }
  };
  const userData = getUserFromLocalStorage();
  const [emailId, setEmailId] = useState(userData ? userData.email : "");
  const [buyerName, setBuyerName] = useState(userData ? userData.name : "");
  const [buyerNumber, setBuyerNumber] = useState(userData ? userData.mobile : "");

  const [activeTab, setActiveTab] = useState("tabs-1"); // Initialize activeTab state

  const handleSeller = (defaultAddress) => {
    dispatch(
      fetchSellers({
        latitude: defaultAddress?.region?.latitude,
        longitude: defaultAddress?.region?.longitude,
        areaCode: defaultAddress?.zipcode,
      })
    );
  };

  useEffect(() => {
    setTempAddress({ ...address, tag: "HOME" });
    setEditAddress({
      ...editAddress, ...address,
      tag: "HOME",
      region: {
        latitude: address?.latitude,
        longitude: address?.longitude,
      },
    });
    if (address?.latitude && searchmodal) {
      setMap(true);
      setSearchModal(false);
    }
  }, [address]);

  const checkValidation = (value) => {
    if (!value || value === undefined || value == null || value === "") {
      return false;
    } else {
      return true;
    }
  };

  const checkEmailPhoneValidation = (type, value) => {
    if (type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    } else if (type === "phone") {
      const phoneRegex = /^\d{10}$/;
      return phoneRegex.test(value);
    } else {
      return true;
    }
  };

  const onChangePincodeDetail = (e) => {
    if (e.target.value !== "" && e.target.value.length >= 3) {
      handleAddress(e.target.value);
    } else {
      store.dispatch(startLoadingMap(false));
      store.dispatch(getLocations([]));
    }
  };
  const debouncedOnChange = debounce(onChangePincodeDetail, 500);
  const SearchResult = (searches, save) => {
    const searchLocations = searches.map((item) => (
      <div
        className="select-location-result-item-kl"
        onClick={() => {
          setTempAddress({});
          placeDetail(item?.place_id);
          setOpenFromEdit(false);
          if (save) {
            store.dispatch(saveSearchHistory(item));
          }
        }}
      >
        <img src={blacksearchIcon} alt="Search Icon" />
        <div>
          <div className="select-location-pin-code-kl">{item?.structured_formatting?.main_text}</div>
          <div className="select-location-description-kl">{item?.description}</div>
        </div>
      </div>
    ));
    return <>{searchLocations}</>;
  };

  const updateAddress = () => {
    setLoadingAddAddress(true);
    const addressId = editAddress.addressId;
    if (!addressId) {
      notify("error", "Address ID is missing in editAddress.");
      setLoadingAddAddress(false);
      return;
    }
    const region = {
      latitude: parseFloat(
        editAddress.latitude
          ? editAddress.latitude
          : editAddress.region?.latitude
      ),
      longitude: parseFloat(
        editAddress.longitude
          ? editAddress.longitude
          : editAddress.region?.longitude
      ),
    };
    if ((buyerName + building + tempAddress.address_line2)?.length > 190) {
      notify("warning", "Max Character limit exceeded, Please write short address");
      return;
    }
    const updatedBody = {
      addressId: addressId,
      contactName: buyerName,
      contactPhone: `+91${buyerNumber}`,
      mobile: buyerNumber,
      city: editAddress?.city,
      state: editAddress?.state,
      zipcode: editAddress?.pincode ? editAddress?.pincode : editAddress?.zipcode,
      address_line1: building ? building : "",
      address_line2: editAddress?.address_line2,
      building: building,
      status: editAddress?.status,
      tag: editAddress?.tag,
      region: region,
      emailId: emailId,
    };

    API.post("/edit-address", updatedBody)
      .then((res) => {
        const data = res?.data;
        if (data?.success) {
          fetchAddress();
        } else {
          notify(
            "error",
            "Error occurred while updating address. Please try again."
          );
        }
        setLoadingAddAddress(false);
      })
      .catch((error) => {
        notify(
          "error",
          "An error occurred while updating address. Please try again."
        );
        setLoadingAddAddress(false);
      });
  };

  const deleteAddress = (address) => {
    API.post("/delete-address", { addressId: address._id })
      .then(({ data }) => {
        if (data) {
          fetchAddress();
          setTempAddress({});
        }
      })
      .catch((error) => {
        handleError(error);
        setTempAddress({});
      });
  };

  const saveAddress = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (userAddress && userAddress.length > 0) {
      const defaultAddress = {
        latitude: userAddress[0]?.region?.latitude,
        longitude: userAddress[0]?.region?.longitude,
        zipcode: userAddress[0]?.zipcode,
        address: userAddress[0],
      };
      localStorage.setItem("defaultAddress", JSON.stringify(defaultAddress));
    }
    const isTagValid = checkValidation(tempAddress?.tag);
    const isBuyerEmailValid = checkValidation(emailId);
    const isPhoneNumberValid = checkValidation(buyerNumber);
    const isPinCodeValid = checkValidation(
      tempAddress?.pincode ? tempAddress?.pincode : tempAddress?.zipcode
    );
    const isLandmarkValid = checkValidation(building);
    const isStateValid = checkValidation(tempAddress?.state);
    const isAddressLine2Valid = checkValidation(tempAddress?.address_line2);
    const isCityValid = checkValidation(tempAddress?.city);
    const isLatitudeValid = checkValidation(
      tempAddress.latitude ? tempAddress?.latitude : tempAddress?.region?.latitude
    );
    const isLongitudeValid = checkValidation(
      tempAddress?.longitude
        ? tempAddress?.longitude
        : tempAddress?.region?.longitude
    );
    if (
      !isTagValid ||
      !isPhoneNumberValid ||
      !isPinCodeValid ||
      !isLandmarkValid ||
      !isStateValid ||
      !isAddressLine2Valid ||
      !isCityValid
    ) {
      notify("warning", "Please enter valid details");
    } else if (
      !openFromEdit &&
      (!isBuyerEmailValid ||
        !isPhoneNumberValid ||
        !isPinCodeValid ||
        !isLandmarkValid ||
        !isStateValid ||
        !isAddressLine2Valid ||
        !isCityValid ||
        !isLatitudeValid ||
        !isLongitudeValid)
    ) {
      notify("warning", "Please enter valid details");
    } else {
      setLoadingAddAddress(true);
      const region = {
        latitude: parseFloat(
          tempAddress.latitude
            ? tempAddress.latitude
            : tempAddress.region?.latitude
        ),
        longitude: parseFloat(
          tempAddress.longitude
            ? tempAddress.longitude
            : tempAddress.region?.longitude
        ),
      };
      if ((buyerName + building + tempAddress.address_line2)?.length > 190) {
        notify("warning", "Max Character limit exceeded, Please write short address");
        return;
      }
      const body = {
        contactName: buyerName,
        contactPhone: `+91${buyerNumber}`,
        mobile: buyerNumber,
        city: tempAddress.city,
        state: tempAddress.state,
        zipcode: tempAddress?.pincode
          ? tempAddress.pincode
          : tempAddress.zipcode,
        address_line1: building,
        address_line2: tempAddress.address_line2,
        building: building,
        status: tempAddress.status,
        tag: tempAddress.tag,
        emailId: emailId,
        region: region,
        userId: get(user, "userId", ""),
        uId: get(user, "_id", ""),
      };
      API.post("/create-address", body)
        .then(async (res) => {
          const data = res?.data;
          if (data.success) {
            const userAddress = await fetchAddress();
            if (userAddress && userAddress.length > 0) {
              const defaultAddress = {
                latitude: userAddress[0]?.region?.latitude,
                longitude: userAddress[0]?.region?.longitude,
                zipcode: userAddress[0]?.zipcode,
                address: userAddress[0],
              };
              localStorage.setItem("defaultAddress", JSON.stringify(defaultAddress));
            }

          } else {
            notify(
              "error",
              "Error occurred while saving address. Please try again."
            );
          }
          setLoadingAddAddress(false);
        })
        .catch((error) => {
          notify(
            "error",
            "Error occurred while saving address. Please try again."
          );
          setLoadingAddAddress(false);
        });
    }
  };
  const fetchAddress = async () => {
    try {
      const user = getUserFromLocalStorage();
      if (!user) {
        notify('error', 'Your session has been expired, Please login again!')
        setTimeout(() => {
          navigate("/");
        }, 3000);
        userLogout()
        return null;
      }
      setAddressStatus("loading");
      const { data } = await API.get(GET_USER_ADDRESS, { params: { userId: get(user, "_id", "") } })
      setAddressStatus("loaded");
      if (data) {
        setUserAddress(data?.addresses);
        return data?.addresses;
      } else {
        return null;
      }
    } catch (error) {
      setAddressStatus("error");
      handleError(error);
      return null;
    }
  };
  const userLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("cart");
    localStorage.removeItem("sellerDetails");
    localStorage.removeItem("slug");
    dispatch(logoutUser());
  };

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      setGetCurrentLocationLoader(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          if (openFromEdit) {
            setEditAddress({
              ...editAddress,
              region: {
                latitude: latitude,
                longitude: longitude,
              },
            });
          }
          else {
            setTempAddress({
              ...tempAddress,
              latitude: latitude,
              longitude: longitude,
            });
          }
          const obj = { latitude, longitude };
          getPlacesDetails(obj);
          setOpenFromEdit(false);
          setMap(true);
          setSearchModal(false);
          setGetCurrentLocationLoader(false);
        },
        (error) => {
          setGetCurrentLocationLoader(false);
          if (error.code === error.PERMISSION_DENIED) {
            notify("error", "Allow location access in your browser to continue");
          } else {
            notify("error", "Error in facting your current location Try Again!");
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const handleGetCurrentLocations = () => {
    const { region } = tempAddress;
    if (
      region &&
      region.latitude !== undefined &&
      region.longitude !== undefined
    ) {
      const latitude = Number(region.latitude);
      const longitude = Number(region.longitude);
      setMap(true);
      setSearchModal(false);
      getPlacesDetails({ latitude, longitude });
    } else {
      console.error(
        "Latitude or longitude is not available in the saved address."
      );
    }
  };

  const handleEditButtonClick = (data) => {
    const addressId = data.addressId || data._id || "";
    setTempAddress({})
    setEditAddress({
      ...data,
      addressId: addressId,
    });
    setOpenFromEdit(true);
    setMap(true);
    setBuyerName(data.contactName || "");
    setEmailId(data.emailId || "");
    setBuilding(data.building || "");
    if (
      data.region &&
      data.region.latitude !== undefined &&
      data.region.longitude !== undefined
    ) {
      handleGetCurrentLocations();
    }
  };

  const isCheckQcPage = () => {
    if (window?.location?.pathname?.includes("qc")) {
      window.location.reload()
    }
  }

  useEffect(() => {
    fetchAddress();
  }, []);

  return (
    <>
      <ToastContainer
        autoClose={300}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />{" "}
      <div className="drawer-header-kl">
        <div className="drawer-header-title-kl">Your Addresses</div>
        <button
          type="button"
          className="btn-close drawer-header-close-btn-kl"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => { setAddressModal(false) }}
        ></button>
      </div>

      <div className="drawer-body-kl p-0">
        <div className="p-4">
          <button
            type="button"
            className="add-address-btn-kl"
            onClick={() => {
              setSearchModal(true);
              setOpenFromEdit();
              store.dispatch(getLocations([]));
            }}
          >
            Add New Address
          </button>
        </div>
        <div className="add-address-list-kl">
          {!userAddress && <EmptyPage
            image={AddressNotFound}
            EmptySubTitle="Address Not Found"
            altText="Address Not Found"
            imgWidth="150px"
            fontSize="16px"
          />}
          {addressStatus === "loading" && <Loader />}
          {addressStatus === "loaded" &&
            userAddress &&
            userAddress.length > 0 ? (
            userAddress.map((data, index) => {
              return (
                <div className="add-address-items" key={data?._id}
                  onClick={() => {
                    if (!isInHeader) {
                      const defaultAddress = {
                        latitude: data?.region?.latitude,
                        longitude: data?.region?.longitude,
                        zipcode: data?.zipcode,
                        address: data,
                      };
                      setZipcode(data?.zipcode);
                      handleSeller(defaultAddress);
                      localStorage.setItem("defaultAddress", JSON.stringify(defaultAddress));
                      localStorage.setItem("locations", JSON.stringify(`${data?.region?.latitude},${data?.region?.longitude}`));
                      setShippingAddress(defaultAddress?.address);
                      isCheckQcPage();
                      if (onAddressSelected) {
                        onAddressSelected();
                      }
                    }
                  }}
                >
                  <div onClick={() => { setAddressModal(false); }}>
                    {!isInHeader && (
                      <input
                        name="plan"
                        defaultChecked={
                          localStorage.getItem("defaultAddress") &&
                          JSON.parse(localStorage.getItem("defaultAddress"))?.address?._id === data._id
                        }
                        className="radio"
                        type="radio"

                      />
                    )}
                    <label className="add-address-radio-wrapper">
                      <div className="plan-details-kl" aria-hidden="true">
                        <div className="customer-name-kl">
                          {data.contactName} <span>({data.tag ? data.tag : "Other"})</span>
                        </div>
                        <div className="phone-email-list-kl">
                          <div className="phone-email-items-kl">{data.contactPhone}</div>
                          <div className="phone-email-items-kl">{data.emailId}</div>
                        </div>
                        <div className="address-line1-kl">{data.address_line2}</div>
                        <div className="address-line1-kl">{data.city} {data.zipcode}</div>
                      </div>
                    </label>
                  </div>

                  <div className="threedots-dropdown-kl">
                    <div className="dropdown">
                      <button
                        className="three-dots-kl"
                        type="button"
                        id="dropdownMenuButton1"
                        aria-haspopup="true"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img src={ThreeDots} className="three-dots-icon-kl" alt="Three Dots" />
                      </button>
                      <div className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <div className="dropdown-item" onClick={() => {
                          setOpenFromEdit(true);
                          fetchAddress();
                          setTempAddress(data);
                          setEditAddress(data);
                          handleEditButtonClick(data);
                          document.getElementById("dropdownMenuButton1").click();
                        }}>
                          Edit
                        </div>
                        <div className="dropdown-item" onClick={() => {
                          setOpenDeletePopup(true);
                          setDeletedAddress(data);
                        }}>
                          Delete
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              );
            })
          ) : (
            <div>
              {addressStatus === "loaded" && addresses.length === 0 && (
                <p>No Address Found!</p>
              )}
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={searchmodal}
        toggle={() => {
          setSearchModal(false);
        }}
        aria-labelledby="contained-modal-title-v"
        ed
        style={{ maxWidth: "600px" }}
        centered
        className="custom-modal-kl"
      >
        <div className="custom-modal-header-kl">
          <div className="custom-modal-title-kl">Select Location</div>
        </div>
        <div className="custom-modal-body-kl select-location-modal-kl">
          <div className="select-location-search-kl">
            <img src={searchIcon} alt="Search1 Icon" className="select-location-search-icon-kl" />
            <input
              className="form-control"
              type="search"
              placeholder="Search for an area , Location name, Pincode"
              onChange={debouncedOnChange}
            />
          </div>
          {loadingMapAddress && !selectAddressLoader && <Loader />}
          <div className="select-location-list-kl">
            <div className="select-location-items">
              <img src={CurrentLocationIcon} alt="Location Icon" className="location-icon-kl" />
              {getCurrentLocationLoader ? (
                <Loader />
              ) : (
                <button type="button"
                  className="current-location-btn-kl"
                  onClick={() => {
                    handleGetCurrentLocation();
                    setBuyerName()
                    setBuilding()
                    setEmailId()

                  }}
                >
                  Use My Current Location{" "}
                </button>
              )}
            </div>
            <div className="select-location-items">
              <img src={LocationPinIcon} alt="Location Icon" className="location-icon-kl" />
              {getCurrentLocationLoader ? (
                <Loader />
              ) : (
                <button type="button"
                  className="current-location-btn-kl"
                  onClick={() => {
                    handleGetCurrentLocation();
                    setBuyerName()
                    setBuilding()
                    setEmailId()
                  }}
                >
                  Locate On Map{" "}
                </button>
              )}
            </div>
          </div>
          <div className="select-location-container-kl">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "tabs-1" ? "active" : ""}`}
                  onClick={() => setActiveTab("tabs-1")}
                >
                  {locations.length > 0 ? "Choose Delivery Location" : "Recent Search"}
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div className={`tab-pane ${activeTab === "tabs-1" ? "active show" : ""}`}>
                <div className={"select-location-result-list-kl"}>
                  {locations.length > 0 ? SearchResult(locations, true) : recentSearches?.length > 0 ? SearchResult(recentSearches, false) : "Your recent searches will appear here."}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={map}
        aria-labelledby="contained-modal-title-v"
        ed
        toggle={() => {
          setMap(false);
        }}
        className="custom-modal-kl confirm-delivery-location-modal modal-md"
        centered
      >
        <div className="custom-modal-header-kl">
          <div className="custom-modal-title-kl">
            <button className="custom-modal-header-back-arrow"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => {
                setMap(false);
              }}
            >
              <img src={ArrowBack} alt="" />
            </button>
            Confirm Delivery Location</div>
          <button
            type="button"
            className="close-icon-kl text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setMap(false);
            }}
          ></button>
        </div>
        <ModalBody className="custom-modal-body-kl">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Full Name*"
                value={buyerName}
                onChange={(e) => {
                  setBuyerName(e.target.value);
                }}
              />
              {checkValidation(buyerName) ? null : (
                <p className="error">Name is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control "
                placeholder="Email Id*"
                value={emailId}
                onChange={(e) => {
                  setEmailId(e.target.value);
                }}
              />
              {checkEmailPhoneValidation("email", emailId) ? null : (
                <p className="error">Please enter a valid email address.</p>
              )}
            </div>
            <div className="dropLocation-modal-kl">
              <div className="dropLocation-modal-lock-kl">
                {
                  <WrappedMap
                    currLatlong1={{
                      latitude: openFromEdit ? parseFloat(editAddress?.region?.latitude) : tempAddress.latitude,
                      longitude: openFromEdit ? parseFloat(editAddress?.region?.longitude) : tempAddress.longitude,
                    }}
                    func={(obj) => {
                      getPlacesDetails(obj);
                    }}
                  />
                }
              </div>
            </div>
            <div className="col-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Area, Colony, Street*"
                value={tempAddress.address_line2 || editAddress.address_line2}
                onChange={(e) => {
                  setTempAddress({
                    ...tempAddress,
                    address_line2: e.target.value,
                  });
                  setEditAddress({ ...editAddress, address_line2: e.target.value });
                }}
              />
              {checkValidation(tempAddress?.address_line2 || editAddress?.address_line2) ? null : (
                <p className="error">This feild is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Building Name*"
                value={building}
                onChange={(e) => {
                  setBuilding(e.target.value);
                }}
              />
              {checkValidation(building) ? null : (
                <p className="error">Building name is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Pincode*"
                value={
                  (tempAddress?.pincode ? tempAddress.pincode : tempAddress.zipcode || editAddress?.pincode ? editAddress.pincode : editAddress.zipcode)
                }
                onChange={(e) => {
                  setTempAddress({ ...tempAddress, pincode: e.target.value });
                  setEditAddress({ ...editAddress, pincode: e.target.value });
                }}
              />
              {checkValidation(
                tempAddress?.pincode ? tempAddress.pincode : tempAddress.zipcode || editAddress?.pincode ? editAddress.pincode : editAddress.zipcode
              ) ? null : (
                <p className="error">Pincode is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="City*"
                value={tempAddress?.city || editAddress?.city}
                onChange={(e) => {
                  setTempAddress({ ...tempAddress, city: e.target.value });
                  setEditAddress({ ...editAddress, city: e.target.value });
                }}
              />
              {checkValidation(tempAddress?.city || editAddress?.city) ? null : (
                <p className="error">City is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="State*"
                value={tempAddress?.state || editAddress?.state}
                onChange={(e) => {
                  setTempAddress({ ...tempAddress, state: e.target.value });
                  setEditAddress({ ...editAddress, state: e.target.value });
                }}
              />
              {checkValidation(
                tempAddress?.state || editAddress?.state
              ) ? null : (
                <p className="error">State is required.</p>
              )}
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="select-location-home-office-container">
                <div className="address-type-title">Address Type</div>
                <div className="select-location-home-office-list">
                  {["HOME", "WORK", "OTHER"].map((tag) => (
                    <div
                      key={tag}
                      className={`select-location-home-office-items ${(tempAddress?.tag?.toLowerCase() === tag.toLowerCase() ||
                        editAddress?.tag?.toLowerCase() === tag.toLowerCase())
                        ? "active"
                        : ""
                        }`}
                      onClick={() => {
                        setTempAddress({ ...tempAddress, tag });
                        setEditAddress({ ...editAddress, tag });
                      }}
                    >
                      {tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase()}
                      <input
                        type="radio"
                        name="gender"
                        checked={
                          tempAddress?.tag?.toLowerCase() === tag.toLowerCase() ||
                          editAddress?.tag?.toLowerCase() === tag.toLowerCase()
                        }
                        onChange={() => {
                          setTempAddress({ ...tempAddress, tag });
                          setEditAddress({ ...editAddress, tag });
                        }}
                      />
                    </div>
                  ))}
                </div>
                {checkValidation(tempAddress?.tag || editAddress.tag) ? null : (
                  <p className="error">Please Select Tag.</p>
                )}
              </div>
            </div>
          </div>
          <button
            disabled={
              !checkValidation(buyerName) ||
              !checkValidation(buyerNumber) ||
              !checkEmailPhoneValidation("email", emailId) ||
              !checkValidation(building)
            }
            className="button-loader-bt-kl"
            type="button"
            onClick={() => {
              if (openFromEdit) {
                updateAddress();
              } else {
                saveAddress();
              }
              setMap(false);
            }}
          >
            {openFromEdit ? "UPDATE" : "SAVE"}
            {loadingAddAddress && <LoaderWhite />}
          </button>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={openDeletePopup}
        toggle={() => {
          setOpenDeletePopup(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal-kl"
      >
        <div className="addressmodalBlock">
          <div className="drawer-header-kl">
            <div className="drawer-header-title-kl">
              Delete Address
            </div>
          </div>
          <div className="drawer-body-kl">
            <p>Are you sure you want to delete this address?</p>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setOpenDeletePopup(false);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger mx-2"
                onClick={() => {
                  setOpenDeletePopup(false);
                  deleteAddress(selectDeleteAddress);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={selectAddressLoader}
        aria-labelledby="contained-modal-title-v "
        ed
        className="loader-modal"
        style={{ maxWidth: "600px", maxHeight: "600px" }}
        centered
      >
        <Loader></Loader>
      </Modal>
    </>
  );
};
export default ManageAddress;
